import React from "react";

import { Props } from "./types";
import { Context, useWorkspaceContext } from "./utils";

function WorkspaceContext(props: Props) {
  return <Context.Provider value={props}>{props.children}</Context.Provider>;
}

export { WorkspaceContext, useWorkspaceContext };
